import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ContactUsSticky from './components/ContactUsSticky';
import ContactForm from './components/ContactForm';

// Page Components
import Home from './pages/Home';
import AboutUsNew from './pages/AboutUsNew';
import ServicesPage from './pages/ServicesPage';
import CaseStudies from './pages/CaseStudies';

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUsNew />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/case-studies" element={<CaseStudies />} />
          </Routes>
        </main>
        <Footer />
        <ContactUsSticky/>
        <ContactForm/>
      </div>
    </Router>
  );
}

export default App; 